import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=6af67aaa&"
import script from "./forgot_password.vue?vue&type=script&lang=js&"
export * from "./forgot_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af67aaa')) {
      api.createRecord('6af67aaa', component.options)
    } else {
      api.reload('6af67aaa', component.options)
    }
    module.hot.accept("./forgot_password.vue?vue&type=template&id=6af67aaa&", function () {
      api.rerender('6af67aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/login/forgot_password.vue"
export default component.exports